import Popover from 'primevue/popover';

const open_popovers = new Set();

export default {
  extends: Popover,
  methods: {
    onEnter(el) {
      open_popovers.forEach((other) => {
        if (other === this) return;
        if (other.container && this.target && other.container.contains(this.target)) return;
        other.hide();
      });
      open_popovers.add(this);
      Popover.methods.onEnter.call(this, el);
    },
    onLeave() {
      open_popovers.delete(this);
      Popover.methods.onLeave.call(this);
    },
  },
  beforeUnmount() {
    open_popovers.delete(this);
  },
};
